import React from "react";
import { message, Popconfirm } from "antd";
import { gql, useMutation } from "@apollo/client";

const DELETEAPURCHASE = gql`
  mutation removePurchase($id: ID!) {
    removePurchase(id: $id)
  }
`;

function DeletePurchase({ id, name, children, onDeletePurchase }) {
  const [runDeletePurchase, deletePurchase] = useMutation(DELETEAPURCHASE, {
    onCompleted({ removePurchase }) {
      if (removePurchase) {
        message.success(`خدمت ${name ? name : ""} حذف شد.`);
        onDeletePurchase();
      }
    },
    onError(err) {
      message.error(err.message);
    },
  });

  const doDeletePurchase = () => {
    runDeletePurchase({
      variables: { id },
    });
  };
  return (
    <>
      <Popconfirm
        title={`حذف ${name ? `خدمت ${name}` : "خدمت"}?`}
        okText="حذف"
        cancelText="خیر"
        onConfirm={doDeletePurchase}
      >
        <span>{children}</span>
      </Popconfirm>
    </>
  );
}

export default DeletePurchase;
